// extracted by mini-css-extract-plugin
export default {"Tags":"MessageAddressList_Tags__XFI5f","InputWrapper":"MessageAddressList_InputWrapper__sK0rp","Input":"MessageAddressList_Input__Bkerg"};